import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import LandingPage from './pages/LandingPage';
import QuestionnairePage from './pages/QuestionnairePage';
import PostQuestionnairePage from './pages/PostQuestionnairePage';
import Chatbot from './pages/Chatbot';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import GrantPage from './pages/GrantPage';
import { FormProvider } from './context/FormContext';
import { QuestionnaireProvider } from './context/QuestionnaireContext';

const theme = createTheme({
  palette: {
    primary: {
      main: '#c79a5f', // amber
      contrastText: '#fff',
    },
    secondary: {
      main: '#9b7b5e', // clay
      contrastText: '#fff',
    },
    background: {
      default: '#f5f5f5',
    },
    forest: {
      main: '#2f3e30', // forest
      contrastText: '#fff',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

function App () {
  return (
    <QuestionnaireProvider>
      <FormProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/ankieta" element={<QuestionnairePage />} />
              <Route path="/ankieta-koncowa" element={<PostQuestionnairePage />} />
              <Route path="/zmiana-pracy" element={<Chatbot />} />
              <Route path="/dotacja" element={<GrantPage />} />
              <Route path="/polityka-prywatnosci" element={<PrivacyPolicyPage />} />
              <Route path="/regulamin" element={<TermsOfServicePage />} />
            </Routes>
          </Router>
        </ThemeProvider>
      </FormProvider>
    </QuestionnaireProvider>
  );
}

export default App;
